import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, LinearProgress,
} from '@mui/material';
import { AccessTime } from '@mui/icons-material';

export default function IdleWarningDialog({ open, countdown, onStayLoggedIn }) {
  const progress  = (countdown / 30) * 100;
  const isUrgent  = countdown <= 10;
  const iconColor = isUrgent ? '#EF5350' : '#F57F17';
  const iconBg    = isUrgent ? '#FFEBEE' : '#FFF8E1';

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, textAlign: 'center' } }}
    >
      <DialogTitle sx={{ pb: 0, pt: 3 }}>
        <Box
          sx={{
            width: 56, height: 56, borderRadius: '14px',
            bgcolor: iconBg,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mx: 'auto', mb: 1.5,
            transition: 'background-color 0.3s',
          }}
        >
          <AccessTime sx={{ fontSize: 30, color: iconColor, transition: 'color 0.3s' }} />
        </Box>
        <Typography variant="h6" fontWeight={700}>Session Expiring Soon</Typography>
      </DialogTitle>

      <DialogContent sx={{ pt: 1.5, pb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          You've been inactive for a while. For your security, you will be signed out in
        </Typography>

        <Typography
          variant="h2"
          fontWeight={800}
          sx={{ color: isUrgent ? 'error.main' : 'warning.main', lineHeight: 1, mb: 0.5, transition: 'color 0.3s' }}
        >
          {countdown}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
          seconds
        </Typography>

        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 6,
            borderRadius: 3,
            bgcolor: isUrgent ? '#FFCDD2' : '#FFF8E1',
            '& .MuiLinearProgress-bar': {
              bgcolor: iconColor,
              borderRadius: 3,
              transition: 'background-color 0.3s',
            },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 2 }}>
        <Button
          variant="contained"
          size="large"
          onClick={onStayLoggedIn}
          sx={{
            px: 5,
            bgcolor: isUrgent ? 'error.main' : 'primary.main',
            '&:hover': { bgcolor: isUrgent ? 'error.dark' : 'primary.dark' },
            transition: 'background-color 0.3s',
          }}
        >
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
}
